import React, { createContext, useContext } from "react";
import { TaskServiceInterface } from "./TaskManagementTypes";

export const TaskListContext: React.Context<TaskServiceInterface | undefined> = createContext<
    TaskServiceInterface | undefined
>(undefined);

export const useTaskListContext = () => {
    const context = useContext(TaskListContext);
    if (context == null) {
        throw new Error("Missing TaskListContext");
    }
    return context;
};
